import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Typography,
  Chip,
} from "@mui/material";
import { useParams } from "react-router-dom";
import moment from "moment";
import CreateLoanModal from "./createLoanModal";
import { getCustomerLoansService } from "../../../../services/loanService";
import useStore from "../../../../useStore";
import { CheckCircle, Cancel } from "@mui/icons-material";
import ReassignLoanModal from "../../../reassignLoan/reassignLoanModal";

function CustomerLoan({ setTabValue }) {
  const { id } = useParams();
  const [loans, setLoans] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const { setLoanId, isLoanSubmit, setLoanSubmit } = useStore();
  const [userName, setUserName] = useState();
  const [isVerified, setIsVerified] = useState(false);
  const [openReassign, setOpenReassign] = useState(false);
  const [selectedLoanId, setSelectedLoanId] = useState(null);

  const getLoan = async () => {
    const fetchLoans = await getCustomerLoansService(id);

    setLoans(fetchLoans?.customerLoans);
    setUserName(fetchLoans?.userName);
    setIsVerified(fetchLoans?.isVerified);
    if (fetchLoans?.isVerified) {
      fetchLoans?.customerLoans.map((loan) => {
        console.log(loan);
        if (loan.status === "Active") {
          setIsDisabled(true);
        }
      });
    } else {
      setIsDisabled(true);
    }

    // if (fetchLoans.status === "Active") {
    //   setIsDisabled(true);
    // } else {
    //   setIsDisabled(false);
    // }
    setLoanId(fetchLoans?.customerLoans[0]?._id);
  };
  const handleOpenReassign = (loanId) => {
    setSelectedLoanId(loanId);
    setOpenReassign(true);
  };

  const getLoanCode = (data) => {
    console.log(data);
    if (data?.loanType === "Group") {
      return data?.groupLoanDetails?.loanCode;
    } else {
      return data?.loanCode;
    }
  };

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    getLoan();
  }, [isLoanSubmit]);

  const handleViewLoan = (id) => {
    setLoanId(id);
    setTabValue(2); // Navigates to "Loan Report" tab (Tab 3)
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          m: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography>
            <strong>Customer Name:</strong> {userName}
          </Typography>
          <Chip
            label={isVerified ? "Verified" : "Not Verified"}
            icon={isVerified ? <CheckCircle /> : <Cancel />}
            color={isVerified ? "success" : "error"}
            variant="outlined"
          />
        </Box>
        <Button
          variant="contained"
          size="small"
          // disabled={isDisabled}
          sx={{
            py: 0.5,
            textTransform: "capitalize",
            fontSize: "16px",
            borderRadius: "8px",
          }}
          onClick={handleOpen}
        >
          Create Loan
        </Button>
        <CreateLoanModal open={open} onClose={handleClose} id={id} />
      </Box>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="customer loan table">
          <TableHead>
            <TableRow>
              <TableCell>Agent Name</TableCell>
              <TableCell>Loan Code</TableCell>
              <TableCell>Frequency</TableCell>
              <TableCell>Loan Tenure</TableCell>
              <TableCell>Total Loan Amount</TableCell>
              <TableCell>Disbursed Amount</TableCell>
              <TableCell>Interest %</TableCell>
              <TableCell>Processing Fee</TableCell>
              <TableCell>Start Date</TableCell>
              <TableCell>End Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loans?.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row?.agentDetails?.userName}</TableCell>
                <TableCell>{row?.loanCode}</TableCell>
                <TableCell>{row?.frequency}</TableCell>
                <TableCell>{row?.loanTenure}</TableCell>
                <TableCell>{row?.loanAmount}</TableCell>
                <TableCell>{row?.disbursedAmount}</TableCell>
                <TableCell>{row?.interest}</TableCell>
                <TableCell>{row?.processingFee}</TableCell>
                <TableCell>
                  {moment(row.startDate).format("DD-MM-YYYY")}
                </TableCell>
                <TableCell>
                  {moment(row.endDate).format("DD-MM-YYYY")}
                </TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => handleViewLoan(row._id)}
                    sx={{ mr: 1 }}
                  >
                    View
                  </Button>
                  {/* <Button variant="contained" color="secondary" size="small">
                    Edit
                  </Button> */}
                </TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={() => handleOpenReassign(row._id)}
                  >
                    Reassign
                  </Button>
                  {/* <Button variant="contained" color="secondary" size="small">
                    Edit
                  </Button> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ReassignLoanModal
        open={openReassign}
        onClose={() => setOpenReassign(false)}
        loanId={selectedLoanId}
        type={"loan"}
      />
    </>
  );
}

export default CustomerLoan;
